import ReactSelect from "react-select";
import { Controller } from "react-hook-form";
import Icon from "./icon";
import { useTranslation } from "./translate";

const DropdownQuestion = ({ name, answers, control, required, labels, readOnlyMode, customPh }) => {
  const answerTranslations = useTranslation(answers.map((ans) => ans.label));

  const options = [
    {
      value: "",
      label: labels?.WELFARE_SELECT_EMPTY_OPTION || "Select...",
      isDisabled: required,
    },
  ].concat(
    answers.map((answer, i) => ({
      value: `${answer.id}`,
      label: answerTranslations[i],
    }))
  );

  return (
    <Controller
      name={name}
      control={control}
      rules={{ required }}
      render={({ field: { onChange, value, ...others } }) => (
        <ReactSelect
          {...others}
          onChange={(x) => onChange(x.value)}
          value={options.find((opt) => opt.value === value)}
          options={options}
          className="survey__select"
          classNamePrefix="survey-select"
          aria-label="survey-dropdown-select"
          isSearchable={false}
          placeholder={customPh || labels?.WELFARE_SELECT_PLACEHOLDER || "Select..."}
          components={{
            IndicatorSeparator: () => null,
            DropdownIndicator: () => <Icon name="angle-down" />,
          }}
          isDisabled={readOnlyMode}
        />
      )}
    />
  );
};

export default DropdownQuestion;
